import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import { deleteArrangement } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';

export const useDeleteArrangements = () => {
  const { t } = useTranslation('common');
  const queryClient = useQueryClient();

  return useCallback((id) => {
    deleteArrangement(id)
      .then(async () => {
        await queryClient.invalidateQueries({
          queryKey: ['travel']
        });
        showSnackbar({
          message: t('adminPortal.arrangements.deleteSuccessfully'),
          severity: 'success'
        });
      })
      .catch(() =>
        showSnackbar({
          severity: 'error',
          message: t('adminPortal.arrangements.deleteWithErrors')
        })
      );
  }, []);
};
